import { useAppSelector } from '@shared/model';
import { EmailSendingReport } from './components/EmailSendingReport/EmailSendingReport';
import { selectIsSendingEmails } from '@entities/sender-state/model';
import { EmailSender } from './components/EmailSender';
import SendingPolling from './components/EmailSender/SendingPolling';
import { selectIsSendingReportShown } from '@pages/invoice-generator/shared/model/reportsSection.selectors';

export const EmailSendingSection = () => {
  const isSendingReportShown = useAppSelector(selectIsSendingReportShown);
  const isSendingEmails = useAppSelector(selectIsSendingEmails);

  console.log('sending section', isSendingEmails);

  return (
    <>
      {isSendingReportShown ? (
        <>
          <EmailSendingReport reportHeaderClassName={'bg-green-ncs'} />
          {isSendingEmails && <SendingPolling />}
        </>
      ) : (
        <EmailSender />
      )}
    </>
  );
};
